import { createContext } from "react";
import type { LaserficheFieldSourceDetails } from "./laserficheFieldSources";
import type { LaserficheInspectField } from "@repo/types";

export interface FieldMappingContextType {
  disabled: boolean;
  mutableId: boolean;
  availableSources: (LaserficheFieldSourceDetails & { key: string })[];
  availableFields: LaserficheInspectField[];
  fieldMap: Record<number, LaserficheInspectField | undefined>;
}

export const FieldMappingContext =
  createContext<FieldMappingContextType | null>(null);
